import React, { useContext, useEffect, useState } from 'react';
import './styles.css';
import { Modal } from '../Modal';
import { FormataValor } from '../../utils/utils';
import { GlobalContext } from '../../contexts/HomeContext';

export const SacolaBar = () => {
  const { dadosApp, sacola, setSacola } = useContext(GlobalContext);
  const [visibility, setVisibility] = useState('none');

  const handleOpenSacola = () => {
    setVisibility(visibility == 'none' ? 'block' : 'none');
  };

  useEffect(() => {
    //ValidDateTimeBasket(dadosApp.IdLoja, setSacola, sacola);
  }, [dadosApp.IdLoja, sacola, setSacola]);

  return (
    <>
      {sacola.TotalItens > 0 && (
        <div
          className="btn_reserve_fixed"
          style={{ boxShadow: '0px -15px 20px -9px rgb(0 0 0 / 20%)' }}
          onClick={handleOpenSacola}
        >
          <a className="btn_1 full-width" style={{ padding: '8px' }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 23">
              <path
                className="st0"
                d="M8.7.2c-1.1 0-2 .3-2.6.9-.6.6-1 1.4-1.2 2.2-.2.6-.3 1.1-.3 1.7H2C.9 5 0 5.9 0 7l.1 13c0 1.7 1.3 3 3 3H15c1.7 0 3-1.3 3-3V7c0-1.1-.9-2-2-2h-3.2c-.1-.6-.1-1.1-.3-1.6-.2-.8-.6-1.7-1.2-2.2-.7-.6-1.5-1-2.6-1zm2.7 6.3v2.6c0 .4.3.7.8.7.4 0 .7-.3.7-.8v-.8-1.8H16c.3 0 .5.2.5.5l-.1 13c0 .8-.7 1.5-1.5 1.5H3.1c-.8 0-1.5-.7-1.5-1.5L1.5 7c0-.3.2-.5.5-.5h2.5v2.6c0 .4.3.8.7.8.4 0 .8-.4.8-.8v-.8-1.8h5.4zM11.3 5c0-.4-.1-.8-.2-1.2-.2-.7-.4-1.2-.8-1.5-.4-.3-.8-.5-1.6-.5s-1.3.2-1.6.5c-.4.3-.6.8-.8 1.5-.1.4-.2.8-.2 1.2h5.2z"
              ></path>
            </svg>
            <span className="itens-count-style">{sacola.TotalItens}</span>
            <span className="verSacola">{dadosApp.TipoApp === 'DELIVERY' ? 'Ver Sacola' : 'Ver Pedido'}</span>
            <span className="valor">{FormataValor(sacola.ValorTotal)}</span>
          </a>
        </div>
      )}

      {/* {visibility === 'block' && sacola.TotalItens > 0 && ( */}
      {visibility === 'block' && (
        <Modal
          title={dadosApp.TipoApp === 'DELIVERY' ? 'Sacola' : 'Pedido: Mesa ' + dadosApp.Mesa}
          isFooter={false}
          visibility={visibility}
          param={{
            origin: 'modal',
            closeModal: handleOpenSacola,
          }}
          page="SACOLA"
          btnOnClickClose={handleOpenSacola}
        />
      )}
    </>
  );
};
